import axios from "axios";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { backendServerBaseURL } from "../../utils/backendServerBaseURL";
import { Form, FormikProvider } from "formik";
import bg_img from "../../assets/svg/components/card-6.svg";
import { Helmet } from "react-helmet-async";

export default function ForgotPassword() {
  const navigate = useNavigate();

  const ValidationSchema = Yup.object().shape({
    email: Yup.string().email("Email must be a valid email address").required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      setSubmitting(true);

      await axios
        .post(`${backendServerBaseURL}/auth/forgot-password`, {
          email: values["email"],
        })
        .then((response) => {
          setSubmitting(false);
          console.log(response.data.data);
          if (response.status === 200 && response.data.message === "Link sent successfully") {
            navigate(`/forgot-password-link-sent-successfully`);
          }
        })
        .catch((error) => {
          setSubmitting(false);
          try {
            console.log(error);
            if (error.response.status === 400) {
              setErrors({ afterSubmit: error.response.data.message });
            }
          } catch (e) {
            console.log(e);
          }
        });
    },
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  return (
    <>
      <Helmet>
        <title>Forgot Password - LightningProxies</title>
      </Helmet>
      <section class="auth-section">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-none d-md-block text-start position-relative">
              {/* <div class="signup-txt-wrap login-txt-box" style={{ marginLeft: "1rem" }}>
                <h2>
                  Welcome back to the #1 Network of <br />
                  Lightning Fast Proxies
                </h2>

                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>

                <img src="./assets/images/auth/register-img.svg" alt="Register" class="img-fluid" />

                <ul>
                  <li>
                    <a href="#">
                      <img src="./assets/images/auth/meta.svg" alt="meta" class="img-fluid" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src="./assets/images/auth/spotify.svg" alt="spotify" class="img-fluid" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src="./assets/images/auth/google.svg" alt="google" class="img-fluid" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src="./assets/images/auth/booking.svg" alt="Booking" class="img-fluid" />
                    </a>
                  </li>
                </ul>
              </div> */}
              <div className="auth-div flex-fill">
                {/* <img src="/assets/images/auth/log-bg.svg" alt="" className="img-fluid" /> */}
                <div className="d-flex flex-column text-start">
                  <h2>
                    Welcome back to the #1 Network of <br />
                    Lightning Fast Proxies
                  </h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
                </div>
                <div className="d-flex ">
                  <img src="./assets/images/auth/register-img.svg" alt="Register" class="img-fluid" />
                </div>
                <div className="d-flex ">
                  <img src="./assets/images/auth/social-banner.svg" alt="Register" class="img-fluid" />
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 left-part-auth">
              <div class="auth-logo-wrap text-start">
                <a href="#" className="d-lg-none ">
                  <img src="./assets/images/logo.svg" alt="Logo" class="img-fluid" />
                </a>
                <a href="#" className="d-none d-lg-block " style={{ marginLeft: "2.5rem" }}>
                  <img src="./assets/images/logo.svg" alt="Logo" class="img-fluid" />
                </a>
              </div>
              <div class="signup-form-wrap login-form-box text-start flex-fill" style={{ marginTop: "10rem" }}>
                <h1>
                  <a href="/login">
                    <img src="./assets/images/icons/arrow-left.svg" alt="Logo" class="img-fluid" />
                  </a>{" "}
                  Forgot Password
                </h1>
                <p>Enter your registered email to reset password</p>
                <FormikProvider value={formik}>
                  <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <div class="form-group">
                      <label for="">Registered Email Address</label>
                      <input {...getFieldProps("email")} type="text" placeholder="Enter Email" class="pchold form-control" />
                      <span
                        className="invalid-feedback"
                        style={{
                          display: Boolean(touched.email && errors.email) ? "block" : "none",
                        }}
                      >
                        {errors.email}
                      </span>
                    </div>
                    <div class="submit-bttn mb-5">
                      <button type="submit" class="btn btn-submit">
                        Send Reset Link
                      </button>
                    </div>
                    {/* Errors from server */}
                    {errors.afterSubmit && (
                      <div className="alert alert-danger mb-5" role="alert">
                        {errors.afterSubmit}
                      </div>
                    )}
                  </Form>
                </FormikProvider>

                <div class="credential-ftr-txt top-100">
                  <p>&copy; 2023 Lightning Proxies. All rights reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
